<template>
  <div v-if="visibleTags.length" class="-tw-mt-2 lg:tw-max-w-[200px] xl:tw-max-w-none">
    <WdsLabel
      v-for="tag in visibleTags"
      :key="tag.name"
      :sm="tag.sm || sm"
      :md="tag.md || md"
      :lg="tag.lg || lg"
      :gray="tag.gray || gray"
      :primary="tag.primary || primary"
      :error="tag.error || error"
      :warning="tag.warning || warning"
      :success="tag.success || success"
      :disabled="tag.disabled || disabled"
      :subtle="tag.subtle || subtle"
      class="tw-mr-2 tw-mt-2"
    >
      {{ tag.name }}
    </WdsLabel>
    <WdsTooltip v-if="additionalTags.length" :global="tooltipIsGlobal">
      <template #tooltip-content>
        <div class="tw-flex tw-items-center tw-gap-2 tw-text-gray-600 tw-mb-2">
          <slot name="tooltip-header">
            <WdsIcon name="tag" :size="16" />
            {{ $t('Tags') }}
          </slot>
        </div>
        <div
          v-for="additionalTag in additionalTags"
          :key="additionalTag"
          class="tw-text-left tw-mb-2"
        >
          {{ additionalTag }}
        </div>
      </template>
      <WdsLabel
        :sm="sm"
        :md="md"
        :lg="lg"
        :gray="gray"
        :primary="primary"
        :error="error"
        :warning="warning"
        :success="success"
        :disabled="disabled"
        :subtle="subtle"
        class="tw-mt-2"
      >
        {{ `+${additionalTags.length}` }}
      </WdsLabel>
    </WdsTooltip>
  </div>
  <div v-else>
    <slot name="empty-state">-</slot>
  </div>
</template>

<script setup lang="ts">
import { WdsLabel, WdsIcon, WdsTooltip } from '@worksome/wds-components'
import { $t } from '@/composables/translation'

type Label = {
  sm?: boolean
  md?: boolean
  lg?: boolean
  gray?: boolean
  primary?: boolean
  error?: boolean
  warning?: boolean
  success?: boolean
  disabled?: boolean
  subtle?: boolean
}

type Tag = {
  name: string
} & Label

type Props = {
  visibleTags?: Tag[]
  additionalTags?: string[]
  tooltipIsGlobal?: boolean
} & Label

withDefaults(defineProps<Props>(), {
  visibleTags: () => [],
  additionalTags: () => [],
  tooltipIsGlobal: false,
})
</script>
